<template>
    <el-container>
        <el-main>
            <el-form label-width="100px" :model="addVisit" size="mini" :rules="rules" ref="form">
                <el-form-item label="1.姓名" prop="visitname" required>
                    <el-input type="input" v-model.trim="addVisit.visitname"></el-input>
                </el-form-item>
                <el-form-item label="2.手机号码" prop="memberphone" required>
                    <el-input type="input" v-model.trim="addVisit.memberphone"></el-input>
                </el-form-item>
                <el-form-item label="3.日期" prop="visitdate" required>
                    <el-date-picker value-format="yyyy-MM-dd" style="width: 100%"
                                    v-model="addVisit.visitdate" type="date" placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="4.门店地址" prop="storeid" required class="address">
                    <el-select v-model="addVisit.storeid" placeholder="请选择" style="width: 100%" size="mini" @change="storeChange">
                        <el-option v-for="item in storeData" :key="item.brandid" :label="item.brandname" :value="item.brandid">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="5.体验项目" prop="projectname" required>
                    <el-select v-model="addVisit.projectname" placeholder="请选择" style="width: 100%" size="mini">
                        <el-option label="五行疗愈" value="五行疗愈"></el-option>
                        <el-option label="MBK清洁补水" value="MBK清洁补水"></el-option>
                        <el-option label="60分钟草本背部" value="60分钟草本背部"></el-option>
                        <el-option label="INDIBA" value="INDIBA"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="generateQR()">分享</el-button>
                    <el-button type="primary" @click="resFrom()">刷新</el-button>
                </el-form-item>
            </el-form>
            <!--<div class="input-group">
                <label>二维码预览</label>
                <div class="qr-container">
                    <vue-qr
                        ref="qrCode"
                        :text="qrContent"
                        :size="200"
                        :margin="10"
                        :dot-scale="1"
                        :logo-margin="3"
                        :logo-corner-radius="10"
                        :auto-color="true"
                        @ready="onQrReady"
                    ></vue-qr>
                </div>
            </div>-->
        </el-main>
    </el-container>
</template>

<script>
import * as ww from '@wecom/jssdk'

export default {
    data() {
        return {
            storeData:[],
            visitlogo:"https://image.shmiaojie.cn/check/20250707202503822.jpg",
            qrImageData:null,
            qrContent:"",
            addVisit:{},
            visit:{
                storeid:"",
                storename:"",
                memberphone:"",
                projectname:"",
                visitname:"",
                visitdate:"",
                sysbillid:"",
                iwrite:0,
                v01:-1,
                v02:-1,
                v03:-1,
                v04:-1,
                v05:-1,
                v06:-1,
                v07:-1,
                v08:-1,
                v09:-1,
                v10:-1,
                v11:-1,
                v12:-1,
            },
            rules:{
                visitname: [
                    {required: true, message: "请输入您的姓名", trigger: 'change'},
                ],
                storeid: [
                    {required: true, message: "请选择门店地址", trigger: 'blur'}
                ],
                projectname: [
                    {required: true, message: "请选择体验项目", trigger: 'blur'}
                ],
                visitdate: [
                    {required: true, message: "请选择体验日期", trigger: 'blur'}
                ],
                memberphone: [
                    {required: true, message: "请输入您的手机号码", trigger: 'blur'},
                    {pattern:/^(?:(?:\+|00)86)?1[3-9]\d{9}$/,message: "请输入正确的手机号码"}
                ],
            }
        }
    },
    created() {
        this.addVisit=this.$copy(this.visit);
        this.getSysBillId();
        this.get_store_position_info();
        ww.register({
            corpId:"wwb9fb80fecb56fde3",
            jsApiList:["shareWechatMessage"],
            getConfigSignature:(url)=>{
                return new Promise((resolve,reject)=>{
                    this.$post('htyswechat/getHtysJsSignature',{url:url}).then(res=>{
                        if(res.sucess){
                            let timestamp=res.object.timestamp;
                            let nonceStr=res.object.nonceStr;
                            let signature=res.object.signature;
                            resolve({ timestamp,nonceStr,signature});
                        }
                        else{
                            reject(res);
                        }
                    });
                })
            }
        });

        //console.log(ww);
    },
    methods:{
        async getVisitById(){
            await this.$post('returnvisit/getVisitById',{sysbillid: this.addVisit.sysbillid}).then(res=>{
                if(res.sucess){
                    if(res.object!=null){
                        this.addVisit=res.object;
                    }
                }
                else{
                    this.$message.error(res.message);
                }
            });
        },
        saveVisit() {
            this.$refs["form"].validate((valid) => {
                if (valid) {

                }
            });
        },
        async butShare(link){
            console.log(link);
            link=encodeURI(link);

            await this.getVisitById();

            if(!this.addVisit.createdate) {
                await this.$postw("returnvisit/saveVisit", this.addVisit).then(res => {
                    this.isLoading = false;
                    if (res.sucess) {
                        this.$message.success("保存成功");
                    } else {
                        this.$message.error(res.message);
                        return false;
                    }
                });
            }

            ww.shareWechatMessage({
                title:"花田悦舍体验官调查表",
                desc:"尊敬的"+this.addVisit.visitname+"您好,请点击参与体验调查",
                link:link,
                imgUrl:this.visitlogo,
                success:()=> {
                    this.$message.success("分享成功");
                    this.resFrom();
                }
            });
        },
        resFrom(){
            this.addVisit=this.$copy(this.visit);
            this.getSysBillId();
            if (this.$refs["form"]) {
                this.$refs["form"].resetFields();
            }
        },
        // 执行浏览器命令 Copy 顺便输出一下日志，如果在移动端推荐写个方法展示日志或者用alert(msg)也行。
        _execCommand(action) {
            let is = document.execCommand(action);
            if (is) {
                console.log("复制成功");
            } else {
                console.log("复制失败");
            }
        },
        // 检测是否iOS端
        iosAgent() {
            return navigator.userAgent.match(/(iPhone|iPod|iPad);?/i);
        },
        // 复制文本函数，微信端，需要在用户触发 Click 事件里面才能执行成功
        copy(message) {
            message=encodeURI(message);
            if (this.iosAgent()) {
                //console.log("input 复制方式 " + message);
                let inputObj = document.createElement("input");
                inputObj.value = message;
                document.body.appendChild(inputObj);
                inputObj.select();
                inputObj.setSelectionRange(0, inputObj.value.length);
                this._execCommand('Copy');
                document.body.removeChild(inputObj);
            } else {
                //console.log("document 复制方式 " + message);
                let domObj = document.createElement("span");
                domObj.innerHTML = message;
                document.body.appendChild(domObj);
                let selection = window.getSelection();
                let range = document.createRange();
                range.selectNodeContents(domObj);
                selection.removeAllRanges();
                selection.addRange(range);
                this._execCommand('Copy');
                document.body.removeChild(domObj);
            }
        },
        storeChange(val){
            for(let store of this.storeData){
                if(store.brandid==val){
                    this.addVisit.storename=store.brandname;
                }
            }
        },
        generateQR() {
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    this.qrContent="http://shhtys.cn/#/visitcust?storeid="+this.addVisit.storeid+"&storename="
                        +this.addVisit.storename+"&memberphone="+this.addVisit.memberphone+"&visitname="+this.addVisit.visitname+"&visitdate="+this.addVisit.visitdate
                    +"&projectname="+this.addVisit.projectname+"&sysbillid="+this.addVisit.sysbillid;
                    this.butShare(this.qrContent);
                }
            });
        },
        onQrReady(data){
            this.qrImageData=data;
        },
        getSysBillId() {
            this.$post('product/getSysBillId').then(res=>{
                if (res.sucess) {
                    this.addVisit.sysbillid = res.object;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        get_store_position_info() {
            //门店数据
            this.$post('store/getStoreInfoByStructsOpen', {storeid: "6862df117e404dffac984820fe15e320"}).then(res=>{
                if(res.sucess){
                    this.storeData = res.object;
                    if(this.storeData!=null && this.storeData.length>0){
                        this.storeData=this.storeData.filter(item=>item.brandid!='6862df117e404dffac984820fe15e320')
                    }
                }
                else{
                    this.$message.error(res.message);
                }
            });
        },
    }
}
</script>
<style>
.input-group {
    margin-bottom: 20px;
}

.qr-container {
    display: flex;
    justify-content: center;
    padding: 20px 0;
    margin: 20px 0;
    background: #f8f9ff;
    border-radius: 12px;
    border: 1px dashed #e0e0e0;
    position: relative;
}
</style>


// WEBPACK FOOTER //
// src/page/check/visit.vue